import { render, staticRenderFns } from "./HomeCompany.vue?vue&type=template&id=0ba6902a&"
import script from "./HomeCompany.vue?vue&type=script&lang=js&"
export * from "./HomeCompany.vue?vue&type=script&lang=js&"
import style0 from "./HomeCompany.vue?vue&type=style&index=0&id=0ba6902a&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports